import React, { useImperativeHandle } from 'react';
import { noop } from '@highlight-ui/utils-commons';
import { Button } from '@highlight-ui/button';

import styles from './SubmitFooter.module.scss';
import { SelectOption, SubmitFooterProps } from '../types';

export type SubmitFooterHandle = {
  cancel: () => void;
};

type PassedProps<T> = {
  handleVisibility?: typeof noop;
  submitRef: React.Ref<SubmitFooterHandle>;
  selectedOptions: T[];
  onKeyDown?: (
    e: React.KeyboardEvent<HTMLElement>,
    isLastElement?: boolean,
  ) => void;
};

const SubmitFooter = <T extends SelectOption>({
  onSubmit,
  onCancel,
  submitLabel = 'Apply',
  cancelLabel = 'Cancel',
  ...passedProps
}: SubmitFooterProps<T>) => {
  const {
    submitRef,
    handleVisibility = noop,
    selectedOptions,
    onKeyDown = noop,
  } = passedProps as PassedProps<T>;

  useImperativeHandle(
    submitRef,
    () => ({
      cancel() {
        onCancel();
      },
    }),
    [onCancel],
  );

  return (
    <footer className={styles.submitFooterContainer}>
      <Button
        variant="plain"
        onClick={() => {
          onCancel();
          handleVisibility();
        }}
        onKeyDown={onKeyDown}
        className={styles.cancelButton}
      >
        {cancelLabel}
      </Button>

      <Button
        variant="emphasized"
        onClick={() => {
          onSubmit(selectedOptions);
          handleVisibility();
        }}
        onKeyDown={(e) => onKeyDown(e, true)}
      >
        {submitLabel}
      </Button>
    </footer>
  );
};

export default SubmitFooter;
